import { create } from "zustand";

interface UnsavedChangesState {
  unsavedChanges: boolean;
  setUnsavedChanges: (unsavedChanges: boolean) => void;
  pendingNavigation: string | null;
  setPendingNavigation: (path: string | null) => void;
}

const useUnsavedChangesStore = create<UnsavedChangesState>((set, get) => ({
  pendingNavigation: null,
  setPendingNavigation: (path) => set({ pendingNavigation: path }),
  unsavedChanges: false,
  setUnsavedChanges: (unsavedChanges) => set({ unsavedChanges }),
}));

export default useUnsavedChangesStore;
